module.exports = __webpack_public_path__ + "img/统计区.jpg";